import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PROGRAMS } from "@/content";
import { scrollToId } from "@/components/Navbar";

export default function Programs() {
  const [big, ...rest] = PROGRAMS;
  return (
    <section id="programs" data-testid="programs-section" className="py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl mb-12"
        >
          <p className="font-head font-bold text-sm tracking-[0.2em] text-terracotta mb-4">
            અમારા કાર્યક્રમો
          </p>
          <h2 className="font-display text-ink text-4xl sm:text-5xl leading-snug">
            સહાયના ચાર સ્તંભ
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-12 gap-5">
          <motion.button
            data-testid={`program-card-${big.id}`}
            onClick={() => scrollToId("donate")}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7 }}
            className="group lg:col-span-7 relative overflow-hidden rounded-2xl text-left min-h-[380px] lg:min-h-[460px] shadow-[0_8px_30px_rgb(0,0,0,0.06)]"
          >
            <img
              src={big.image}
              alt={big.title}
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/30 to-transparent" />
            <div className="absolute bottom-0 p-7 sm:p-9">
              <h3 className="font-display text-cream text-2xl sm:text-3xl mb-3">
                {big.title}
              </h3>
              <p className="text-cream/85 text-sm sm:text-base max-w-md leading-relaxed">
                {big.desc}
              </p>
            </div>
            <div className="absolute top-5 right-5 w-11 h-11 rounded-full bg-cream flex items-center justify-center group-hover:bg-saffron transition-colors duration-200">
              <ArrowUpRight className="w-5 h-5 text-ink group-hover:text-cream transition-colors duration-200" />
            </div>
          </motion.button>

          <div className="lg:col-span-5 grid gap-5">
            {rest.map((p, i) => (
              <motion.button
                key={p.id}
                data-testid={`program-card-${p.id}`}
                onClick={() => scrollToId("donate")}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: 0.1 + i * 0.1 }}
                className="group flex items-stretch gap-5 rounded-2xl border border-stone-200 bg-cream p-5 text-left shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:-translate-y-1 hover:shadow-[0_16px_40px_rgb(0,0,0,0.08)] transition-all duration-200"
              >
                {p.image && (
                  <div className="w-24 sm:w-32 shrink-0 overflow-hidden rounded-xl">
                    <img
                      src={p.image}
                      alt={p.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                )}
                <div className="flex-1 py-1">
                  <h3 className="font-head font-bold text-ink text-lg mb-1.5">
                    {p.title}
                  </h3>
                  <p className="text-ink/65 text-sm leading-relaxed">{p.desc}</p>
                </div>
              </motion.button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
